<template>
  <div class="nav">
    <!-- 左侧 Logo -->
    <div class="nav1">
     <div class="nav2">
      <div @click="navigateTo('/home')" class="left">
        <img src="@/assets/hbjcz.png" alt="Logo">
      </div>

      <!-- 中间标题和一级导航栏 -->
      <div class="title">
        <div class="nav-items">
          <div
            v-for="item in navItems"
            :key="item.name"
            class="nav-item"
            @mouseenter="handleNavItemHover(item)"
            @mouseleave="handleNavItemLeave"
            @click="handleNavItemClick(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
     </div>
    </div>

    <!-- 二级导航栏 -->
    <div
      v-if="hoveredNavItem && currentSubNav"
      class="sub-nav"
      @mouseenter="handleSubNavEnter"
      @mouseleave="hideSubNav"
    >
      <div class="sub-nav-container">
        <div
          v-for="subItem in currentSubNav"
          :key="subItem.name"
          class="sub-nav-item"
          @click="navigateTo(subItem.path)"
        >
          {{ subItem.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopNav',
  data () {
    return {
      showNav: false, // 控制导航栏显示与隐藏
      hoveredNavItem: '', // 当前悬停的一级导航项
      currentSubNav: [], // 当前显示的二级导航项
      navItems: [
        {
          name: '关于公司',
          subNav: [
            { name: '江城子简介', path: '/introduce' },
            { name: '发展历程', path: '/development' },
            { name: '领导致辞', path: '/company' }
          ]
        },
        { name: '产品中心', path: '/product' },
        { name: '工程案例', path: '/engineering' },
        { name: '技术服务', path: '/product' },
        { name: '企业证书', path: '/honour' },
        { name: '联系我们', path: '/contact' }
      ]
    }
  },
  methods: {
    // 打开导航栏
    openNav () {
      this.showNav = true
      document.body.style.overflow = 'hidden' // 禁用页面滚动
    },
    // 关闭导航栏
    closeNav () {
      this.showNav = false
      document.body.style.overflow = 'auto' // 启用页面滚动
    },
    // 跳转到指定路由
    navigateTo (path) {
      if (path && this.$route.path !== path) {
        this.$router.push(path)
      }
      this.closeNav()
    },
    // 处理一级导航项悬停
    handleNavItemHover (item) {
      if (item.subNav) {
        this.hoveredNavItem = item.name
        this.currentSubNav = item.subNav
      }
    },
    // 处理一级导航项离开
    handleNavItemLeave () {
      // 不需要立即隐藏二级导航栏
    },
    // 处理二级导航栏进入
    handleSubNavEnter () {
      // 当鼠标进入二级导航栏时，保持显示
    },
    // 隐藏二级导航栏
    hideSubNav () {
      this.hoveredNavItem = ''
      this.currentSubNav = []
    },
    // 处理一级导航项点击
    handleNavItemClick (item) {
      if (!item.subNav) {
        this.navigateTo(item.path)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.nav {
  display: flex;
  flex-direction: column; /* 垂直排列 */
  position: fixed;
  width: 100%;
  font-family: SimSun;
  color: #000;
  background-color: white; /* 确保 nav 有背景色，避免内容透过来 */
  z-index: 1000; /* 确保 nav 在最上层 */
}

.nav1 {
  display: flex;
  width: 100%;
  min-width: 1200px;
  padding: 20px;
  justify-content: center;
  align-items: center;
  padding: 5px 0;
}

.nav2 {
  display: flex;
  width: 80%;
  min-width: 1200px;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
}

.left {
  display: flex;
}

.left img {
  height: 50px;
}

.title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
}

.nav-items {
  display: flex;
  margin-left: 20px;
}

.nav-item {
  margin: 0 10px;
  cursor: pointer;
  position: relative;
}

.nav-item:hover {
  color: #004da0;
}

.sub-nav {
  width: 100%;
  background-color: white; /* 白色背景 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center; /* 水平居中 */
}

.sub-nav-container {
  display: flex;
  justify-content: space-around; /* 水平均匀分布 */
  max-width: 1200px; /* 限制内容宽度 */
  width: 100%; /* 设置宽度为100% */
  padding: 10px 0; /* 上下内边距 */
}

.sub-nav-item {
  padding: 10px 20px; /* 左右内边距 */
  white-space: nowrap;
  cursor: pointer;
  font-family: SimSun;
  color: #000;
  font-size: 14px;
}

.sub-nav-item:hover {
  color: #004da0;
}

.right {
  flex: 1;
  text-align: right;
  padding-right: 20px;
}

.right button {
  background-color: #004da0;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
